import { render, staticRenderFns } from "./UserDialog.vue?vue&type=template&id=6bb522b5"
import script from "./UserDialog.vue?vue&type=script&lang=js"
export * from "./UserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports